import { IActivityEntityBase } from '@components/widgets/activities';
import { GetUserAuditTrailsResponse } from '@features/salesforce/users/types';

export function extractIconUrl(html: string): string | undefined {
  const match = html.match(/background-image: url\('(.+?)'\)/);

  return match ? match[1] : undefined;
}

export function convertAuditTrailsToActivities(
  data: GetUserAuditTrailsResponse
): IActivityEntityBase[] {
  return data.core.getEntityAuditTrails.map((auditTrail) => {
    const createdOn = new Date(auditTrail.createdOn);

    const localDate = createdOn.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });

    const localTime = createdOn.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    const formattedDate = `${localDate} at ${localTime}`;

    const htmlBody = auditTrail.message.replace(
      /\d{2} \w+ \d{4} at \d{2}:\d{2}:\d{2}/,
      formattedDate
    );

    return {
      id: auditTrail.id,
      createdAt: createdOn,
      htmlBody,
      iconUrl: extractIconUrl(htmlBody)
    };
  });
}
